export const TERMS_CONDITIONS_URL = '/chery/about/terms-conditions/processing-personal-data/';

export const SOCIAL_NETWORK_URL = {
  vk: 'https://vk.com/cheryrussia',
  odnoklassniki: 'https://ok.ru/group/53683542098091',
  tg: 'https://t.me/cheryru',
  youtube: 'https://www.youtube.com/user/rucherycars',
  zen: 'https://zen.yandex.ru/id/5e676131cf715c1ee9b75c74',
  // fb: "https://www.facebook.com/cheryinternational",
  // instagram: "https://www.instagram.com/cheryauto",
};
